import { VFC } from 'react'
import { MasterData } from 'src/models/MasterData'
import { _profilegreen } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

export const FilterSettingParams: VFC<{
  title: string
  selectedItems: string[] | number[]
  masterData?: MasterData[]
}> = ({ title, selectedItems, masterData }) => {
  return (
    <>
      <FilterParams>
        <FilterParamTableTitle>
          <div>・</div>
          {title}
        </FilterParamTableTitle>
        <FilterParamTableContent>
          <FilterParamTableItemsContent>
            {selectedItems.map((item: string | number) => {
              let label
              if (masterData) {
                const data = masterData.find((t) => {
                  return t.value === String(item)
                })
                label = data?.label
              } else label = item
              return (
                <FilterParamTableItemContent key={item}>
                  <FilterParamTableDiv>{label}</FilterParamTableDiv>
                </FilterParamTableItemContent>
              )
            })}
          </FilterParamTableItemsContent>
        </FilterParamTableContent>
      </FilterParams>
    </>
  )
}

const FilterParams = styled.div`
  display: flex;
  flex-direction: row;
`
const FilterParamTableTitle = styled.div`
  margin: 12px 0px;
  width: 150px;
  font-size: 14px;
  font-weight: 700;

  div {
    line-height: 12px;
    display: inline-block;
    margin-right: 10px;
    font-size: 32px;
    transform: translate(0px, 8px);
  }
`

const FilterParamTableContent = styled.div`
  margin: 6px 0px;
  flex: 9;
`

const FilterParamTableItemsContent = styled.div`
  max-width: 100%;
`

const FilterParamTableItemContent = styled.span`
  display: inline-block;
  margin: 8px 8px;
  padding: 4px 16px;
  background: #f3fbfa;
  border-radius: 14px;
`

const FilterParamTableDiv = styled.span`
  max-width: 100%;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${_profilegreen};
  font-weight: ${fontWeightBold};
`
